import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import LNFSideMenu from 'components/side-menu/lnf-side-menu';
import DrawPage from 'components/pages/draw-page';

const LNFContainer = ({ isLite, queryObject }) => {
  const classes = useStyles();
  const { container, sideMenu, drawPage } = classes;

  return (
    <Box className={container}>
      <Box className={sideMenu}>
        <LNFSideMenu />
      </Box>
      <Box className={drawPage}>
        <DrawPage
          isLite={isLite}
          characterType={queryObject.characterType}
          characterCase={queryObject.characterCase}
          character={String(queryObject.character)}
          queryObject={queryObject}
        />
      </Box>
    </Box>
  );
};

export default LNFContainer;

const useStyles = makeStyles({
  container: {
    margin: 'auto',
    width: '100%',
    height: '100%',
    border: '1px solid #cccccc',
    borderRadius: 5,
    display: 'flex',
    flexDirection: 'row',
    fontFamily: 'Futura-Semibold',
  },
  sideMenu: {
    width: '20%',
    minWidth: '230px',
    borderRight: '1px solid #cccccc',
    backgroundColor: '#fff',
    zIndex: 10,
    overflowY: 'auto'
  },
  drawPage: {
    width: '80%',
    height: '100%'
  },
});
